import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateValidationModel } from "../../models/validationrules/CreateValidationModel";
import { TestValidationRuleRequest } from "../../models/validationrules/TestValidationRuleRequest";
import { UpdateValidationModel } from "../../models/validationrules/UpdateValidationModel";

const RESOURCE_NAME = "businessrule";

const getAll = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/GetAll`, requestConfig());
};

const create = (model: CreateValidationModel) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/Create`, model, requestConfig());
};

const update = (model: UpdateValidationModel) => {
  const http = getAxiosInstance();
  return http.put(
    `${RESOURCE_NAME}/Update/${model.id}`,
    model,
    requestConfig()
  );
};

const remove = (validationId: number) => {
  const http = getAxiosInstance();
  return http.delete(
    `${RESOURCE_NAME}/Delete/${validationId}`,
    requestConfig()
  );
};

const getAllCategories = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/GetAllCategories`, requestConfig());
};

const test = (model: TestValidationRuleRequest) => {
  const http = getAxiosInstance();
  return http.post(
    `${RESOURCE_NAME}/test`,
      model,
    requestConfig()
  );
}

const ValidationRulesService = {
  getAll,
  create,
  update,
  remove,
  getAllCategories,
  test,
};
export default ValidationRulesService;
